import React, { useState, Fragment } from 'react';
import { Button, ButtonGroup, makeStyles } from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'center',
        borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    button: {
        fontWeight: 'bold',
        padding: theme.spacing(0.1, 2), // Reduced padding for a slimmer height
        borderRadius: theme.spacing(1),
        textTransform: 'capitalize',
        transition: 'all 0.3s ease',
        fontSize: '12px', // Smaller font size
        width:'100px',
    },
    selectedButton: {
        backgroundColor: theme.palette.secondary.main, // Use secondary color
        color: '#fff',
        '&:hover': {
            backgroundColor: theme.palette.secondary.dark, // Darker secondary color on hover
        },
    },
    label: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#333',
    },
}));

function newDatesBack(old_time_frame, new_time_frame, old_dates_back) {
    let proportions = { day_of_month: 12, time: 365, day_of_week: 52, month: 1, year: 0 };
    if (old_time_frame == 'year' || new_time_frame == 'year') { return 0; }
    return Math.round(old_dates_back * proportions[new_time_frame] / proportions[old_time_frame]);
}

function TimePeriodSelector(props) {
    const classes = useStyles();
    let time_frame=props.time_frame;
    let dates_back=props.dates_back;
    let time_title=props.time_title;

    // Handle time period change
    function setTimeFrame(new_time_frame, dates_back){
        let new_dates_back = newDatesBack(time_frame, new_time_frame, dates_back); 
        props.setDatesBack(new_dates_back, { time_frame: new_time_frame });
        props.setTimeFrame(new_time_frame);
    };


    

    return (
        <Fragment>
        <div className={classes.container}>
            {/* Button Group for Time Periods */}
            <ButtonGroup className={classes.buttonGroup} variant="contained" color="primary">
                <Button
                    onClick={() => setTimeFrame('time', dates_back)}
                    className={`${classes.button} ${time_frame === 'time' ? classes.selectedButton : ''}`}
                >
                    Day
                </Button>
                <Button
                    onClick={() => setTimeFrame('day_of_week', dates_back)}
                    className={`${classes.button} ${time_frame === 'day_of_week' ? classes.selectedButton : ''}`}
                >
                    Week
                </Button>
                <Button
                    onClick={() => setTimeFrame('day_of_month', dates_back)}
                    className={`${classes.button} ${time_frame === 'day_of_month' ? classes.selectedButton : ''}`}
                >
                    Month
                </Button>
                <Button
                    onClick={() => setTimeFrame('month', dates_back)}
                    className={`${classes.button} ${time_frame === 'month' ? classes.selectedButton : ''}`}
                >
                    Year
                </Button>
                <Button
                    onClick={() => setTimeFrame('year', dates_back)}
                    className={`${classes.button} ${time_frame === 'year' ? classes.selectedButton : ''}`}
                >
                    All Time
                </Button>
            </ButtonGroup>
        </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-10px' }}>
                <Typography style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '400px', padding: '0px', border: '1px solid #00598c', borderRadius: '8px', fontSize: '14px', backgroundColor: '#f5f5f5' }}>
                    <div style={{ width: '88px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {(time_frame == 'all_time') ? undefined : <IconButton onClick={() => props.setDatesBack(dates_back + 1, { time_frame })} size="small">
                            <ArrowBackIosIcon color="primary" fontSize="small" />
                        </IconButton>}
                    </div>
                    <div style={{ width: '300px', textAlign: 'center', borderLeft: '1px solid #00598c', color: '#00598c', borderRight: '1px solid #00598c', height: '25px' }}>
                        {time_title}
                    </div>
                    <div style={{ width: '88px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {(time_frame == 'all_time') ? undefined : <IconButton onClick={() => { if (dates_back > 0) { props.setDatesBack(dates_back - 1, { time_frame }) } }} size="small" style={{ marginLeft: '8px', padding: '4px' }}>
                            <ArrowForwardIosIcon color="primary" fontSize="small" />
                        </IconButton>}
                    </div>
                </Typography>
            </div>
        </Fragment>
    );
}

export default TimePeriodSelector;
